
interface Props {
  onClick?: () => void;
  className?: string;
}

export default function IconP(props: Props) {
  const { onClick, className } = props;

  return (
    <div 
      onClick={onClick}
      className={className}
    >
      <span>P</span>
    </div>
  );
}